const computeLeapInterestsAmount = (fundingAmount, annualRate, leapInterestsDuration) => (
    leapInterestsDuration
        ? parseInt(fundingAmount * annualRate * (Math.min(leapInterestsDuration, 18) / 12), 10)
        : 0
);

export default computeLeapInterestsAmount;
